import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[cwEllipsisActive]',
    standalone: false,
})
export class EllipsisActiveDirective {
    @Input() cwEllipsisActiveTimeout = 500;

    constructor(private elementRef: ElementRef) {}

    @HostListener('mouseenter')
    onMouseEnter(): void {
        setTimeout(() => {
            const element = this.elementRef.nativeElement;
            if (element.offsetWidth < element.scrollWidth) {
                element.title = element.textContent;
            } else if (element.title) {
                element.removeAttribute('title');
            }
        }, this.cwEllipsisActiveTimeout);
    }
}
